import React, { Component } from 'react'
import Navbar from './Navbar'
import '../styles/Hero.css'
import BackgroundJpg from '../images/Landing/hero.jpg'
import BackgroundWebp from '../images/Landing/hero.webp'
import BackgroundMobileJpg from '../images/Landing/hero-mobile.jpg'
import BackgroundMobileWebp from '../images/Landing/hero-mobile.webp'
import BoucherJpg from '../images/Landing/hero-boucher.jpg'
import BoucherWebp from '../images/Landing/hero-boucher.webp'
import BoucherMobileJpg from '../images/Landing/hero-boucher-mobile.jpg'
import BoucherMobileWebp from '../images/Landing/hero-boucher-mobile.webp'
import VbnJpg from '../images/Landing/hero-vbn.jpg'
import VbnWebp from '../images/Landing/hero-vbn.webp'
import VbnMobileJpg from '../images/Landing/hero-vbn-mobile.jpg'
import VbnMobileWebp from '../images/Landing/hero-vbn-mobile.webp'
import { injectIntl, defineMessages } from "react-intl"

const heroSlides = [
  {
    jpg: BackgroundJpg,
    webp: BackgroundWebp,
    mobileJpg: BackgroundMobileJpg,
    mobileWebp: BackgroundMobileWebp
  },
  {
    jpg: BoucherJpg,
    webp: BoucherWebp,
    mobileJpg: BoucherMobileJpg,
    mobileWebp: BoucherMobileWebp
  },
  {
    jpg: VbnJpg,
    webp: VbnWebp,
    mobileJpg: VbnMobileJpg,
    mobileWebp: VbnMobileWebp
  }
]

const messages = defineMessages({
  baseline: {
    id: 'hero.baseline',
    defaultMessage: '5 escape games immersifs à Paris 11e'
  },
  subtitle: {
    id: 'hero.subtitle',
    defaultMessage: 'Horreur, enquête, aventure : escape game avec comédiens à Paris'
  },
  reserve: {
    id: 'hero.reserve',
    defaultMessage: 'Réserver'
  },
  googleReviews: {
    id: 'hero.googleReviews',
    defaultMessage: 'Google Avis'
  },
  tripadvisorReviews: {
    id: 'hero.tripadvisorReviews',
    defaultMessage: 'Tripadvisor'
  },
  discoverThemes: {
    id: 'hero.discoverThemes',
    defaultMessage: 'Voir Lost Asylum'
  }
})

class Hero extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isTop: true,
      activeHeroSlide: 0
    }
    this.handleScroll = this.handleScroll.bind(this)
    this.scrollToBooking = this.scrollToBooking.bind(this)
    this.scrollToThemes = this.scrollToThemes.bind(this)
  }

  componentDidMount() {
    document.addEventListener('scroll', this.handleScroll)

    this.heroSliderInterval = window.setInterval(() => {
      this.setState((state) => ({
        activeHeroSlide: (state.activeHeroSlide + 1) % heroSlides.length
      }))
    }, 5000)
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.handleScroll)
    window.clearInterval(this.heroSliderInterval)
  }

  handleScroll() {
    const isTop = window.scrollY < 100;
    if (isTop !== this.state.isTop) {
      this.setState({ isTop })
    }
  }

  scrollToBooking() {
    const target = document.getElementById('homepage-booking')
    if (!target) return

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  scrollToThemes() {
    const target = document.getElementById('themes')
    if (!target) return

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  render() {
    const { intl: { formatMessage } } = this.props
    return (
      <div className='hero'>
        {heroSlides.map((slide, index) => (
          <picture
            className={`hero-picture${index === this.state.activeHeroSlide ? ' hero-picture--active' : ''}`}
            key={slide.jpg}
          >
            <source media="(max-width: 767px)" srcSet={slide.mobileWebp} type="image/webp" />
            <source media="(max-width: 767px)" srcSet={slide.mobileJpg} />
            <source srcSet={slide.webp} type="image/webp" />
            <img
              className="hero-bg"
              src={slide.jpg}
              alt=""
              fetchpriority={index === 0 ? "high" : "auto"}
              loading={index === 0 ? "eager" : "lazy"}
              width={1920}
              height={800}
              tabIndex={-1}
            />
          </picture>
        ))}
        <div className="hero-content">
          <Navbar
            isTop={this.state.isTop}
            lang={this.props.lang}
            handleLang={(lang) => this.props.handleLang(lang)}
          />
          <div className="hero-title">
            <h2>{formatMessage(messages.baseline)}</h2>
            <h3>One Hour</h3>
            <p>{formatMessage(messages.subtitle)}</p>
            <div className="hero-proofs" aria-label="Avis clients">
              <span><strong>4,9/5</strong> {formatMessage(messages.googleReviews)}</span>
              <span><strong>4,9/5</strong> {formatMessage(messages.tripadvisorReviews)}</span>
            </div>
            <button className="hero-cta" type="button" onClick={this.scrollToBooking}>
              {formatMessage(messages.reserve)}
            </button>
          </div>
          <button
            className="hero-scroll-arrow"
            type="button"
            aria-label={formatMessage(messages.discoverThemes)}
            onClick={this.scrollToThemes}
          />
        </div>
      </div>
    )
  }
}

export default injectIntl(Hero)



// WEBPACK FOOTER //
// ./src/components/Hero.js